import styled, { css } from 'styled-components';

export const NotificationWrapper = styled.div(
  ({ theme, isActive = false }) => css`
    background-color: ${isActive
      ? theme.colorsInObjects.mint[200]
      : theme.colors.white};
    padding: ${theme.spacing.m};
    display: flex;
    border-bottom: 1px solid ${theme.colors.platinumDark};
  `
);

export const StyledCircle = styled.div`
  margin-right: ${({ theme }) => theme.spacing.sm};
`;

export const Circle = styled.div(
  ({ theme, color }) => css`
    background-color: ${theme.colors[color]};
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: ${theme.radius.xl};
  `
);

export const NotificationContent = styled.div`
  flex: 1;
`;

export const NotificationDescription = styled.div`
  margin-top: ${({ theme }) => theme.spacing.s};
`;

export const NotificationTitle = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const HeaderContainer = styled.div`
  width: ${({ theme }) => theme.width.full};
  position: fixed;
  top: ${({ theme }) => theme.spacing.none};
  background: ${({ theme }) => theme.colors.oxfordBlue};
  z-index: 2;
`;

export const NoNotificationContent = styled.div`
  text-align: center;
  flex: 1;
`;
